import React, { createContext, useState, useCallback, useMemo, useContext, Fragment } from 'react';

const ModalRouterContext = /*#__PURE__*/createContext(undefined);
const ModalRouterProvider = ModalRouterContext.Provider;

function ModalRouter(props) {
  const [path, setPath] = useState(null);
  const [params, setParams] = useState(null);
  const closeModal = useCallback(() => {
    setPath(null);
  }, [setPath]);
  const state = useMemo(() => ({
    path,
    params
  }), [path, params]);
  const actions = useMemo(() => ({
    setPath,
    setParams,
    closeModal
  }), [setPath, setParams, closeModal]);
  const value = useMemo(() => ({
    state,
    actions
  }), [state, actions]);
  return /*#__PURE__*/React.createElement(ModalRouterProvider, {
    value: value
  }, props.children);
}

function useModalRouter() {
  return useContext(ModalRouterContext);
}

function shouldRender(router, props) {
  if (router.state.path == null) {
    return false;
  }

  if (router.state.path === props.path) {
    return true;
  }

  return false;
}

function ModalRoute(props) {
  const router = useModalRouter();
  const canRender = useMemo(() => {
    return shouldRender(router, props);
  }, [router.state.path, props.path]);

  if (canRender === false) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Fragment, null, props.render({
    router
  }));
}

var useCloseModal = (() => useModalRouter().actions.closeModal);

var useParams = (() => useModalRouter().state.params);

var useParam = (key => {
  var _a;

  return (_a = useParams()) === null || _a === void 0 ? void 0 : _a[key];
});

var usePush = (() => {
  const router = useModalRouter();
  return useCallback((path, params) => {
    router.actions.setPath(path);
    router.actions.setParams(params);
  }, [router]);
});

export { ModalRoute, ModalRouter, useCloseModal, useModalRouter, useParam, useParams, usePush };
